import React, { createContext, useState } from "react";

import PropTypes from "prop-types";
import { message } from "antd";
import { get_companies } from "../services";

export const ClassificationsContext = createContext();

export const ClassificationsProvider = ({ token, children }) => {
	const [classifications, setClassifications] = useState([]); // Backup Simulation for classifications page	
	
	const fetchClassifications = async (companyId, onLoading = () => {}) => {
		if(companyId == null){
			throw new Error("Company ID is null");		
		}
		
		try {
			onLoading(true);

			const res = await get_companies(token, "classifications", { company_id: companyId });

			if(!res) {
				message.error("Error al cargar las clasificaciones");
				onLoading(false);
				return [];
			}

			setClassifications(res);
			onLoading(false);
			message.info("Clasificaciones cargadas");
			return res;
		} catch (err) {
			console.error(err.response.data);
			message.error(err.response.data);
		} finally {
			onLoading(false);
		}

		return [];
	};

	const clearClassifications = () => {
		setClassifications([]);
	};
	
	const fetchClassificationForBankTransactions = async (companyId, onLoading = () => {}) => {
		if(companyId == null){
			throw new Error("Company ID is null");		
		}

		if(classifications.length > 0) return;

		await fetchClassifications(companyId, onLoading);
	};
	
	return (
		<ClassificationsContext.Provider value={{ 
			classifications,
			setClassifications,
			fetchClassifications,
			fetchClassificationForBankTransactions,
			clearClassifications,
		}}>
			{children}
		</ClassificationsContext.Provider>
	);
};

ClassificationsProvider.propTypes = {
	token: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
};